
function getVerifyNoteColor(status) {
  const s = Number(status)
  if ([1, 2, 4, 6].includes(s)) {
    return '#EF7400'
  } else if ([3, 5, 7, 9].includes(s)) {
    return '#d51313'
  } else if ([8].includes(s)) {
    return '#00BB5D'
  }
}

export {
  getVerifyNoteColor,
}


// WEBPACK FOOTER //
// ./src/assets/js/tools.js